import _ from 'lodash';
import {uploadFile} from "actions/MediaLibraryActions";

const initialState = {
  mediaFolders: [],
  mediaFiles: [],
  saving: false,
  pending: false,
  filesToUpload: 0,
  updater: false,
  already_exist: false,
  storeFR: ["main"],
  pixabaySearching:[],
  pixabayFilesCache:[],
  pixabaySearchingTextCache:[],
  pendingP:false,
  already_exist_errors: [],
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case 'GET_MEDIA_LIBRARY_PENDING': {
      return { ...state, pending: true, updater: true, storeFr: ["main"] };
    }
    case 'GET_MEDIA_LIBRARY_FULFILLED': {
      const { mediaFolders, mediaFiles } = payload;
      return { ...state, mediaFolders, mediaFiles, pending: false,  updater: false };
    }
    case 'GET_MEDIA_LIBRARY_FOLDER_PENDING': {
      return { ...state, pending: true, updater: true };
    }
    case 'GET_MEDIA_LIBRARY_FOLDER_FULFILLED': {
      const { mediaFolders, mediaFiles } = state;
      let foldersConcat = mediaFolders;
      let mediaConcat = mediaFiles;
      if(payload.mediaFolders && payload.mediaFolders.length !== 0) {
       foldersConcat = mediaFolders.concat(payload.mediaFolders);
      }
      if(payload.mediaFiles && payload.mediaFiles.length !== 0) {
         mediaConcat = mediaFiles.concat(payload.mediaFiles);
      }
      return { ...state, mediaFolders: foldersConcat, mediaFiles: mediaConcat, pending: false, updater: false };
    }
    case 'GET_MEDIA_LIBRARY_FOLDER_SORTED_PENDING': {
      return { ...state, pending: true, updater: true };
    }
    case 'GET_MEDIA_LIBRARY_FOLDER_SORTED_FULFILLED':{
      const { mediaFolders, mediaFiles } = state;
      let foldersConcat = mediaFolders;
      let mediaConcat = mediaFiles;
      if(payload.mediaFolders && payload.mediaFolders.length !== 0) {
        let filteredFolders = _.filter(mediaFolders, x => x.parent !== payload.mediaFolders[0].parent);
        foldersConcat = filteredFolders.concat(payload.mediaFolders);
      }
      if(payload.mediaFiles && payload.mediaFiles.length !== 0) {
        let filteredFiles = _.filter(mediaFiles, x => x.parent !== payload.mediaFiles[0].parent);
        mediaConcat = filteredFiles.concat(payload.mediaFiles);
      }


      return { ...state, mediaFolders: foldersConcat, mediaFiles: mediaConcat, pending: false, updater: false };
    }
    case 'CREATE_FOLDER_FULFILLED': {
      const mediaFolders = [...state.mediaFolders, payload];
      return { ...state, mediaFolders };
    }
    case 'EDIT_FOLDER_PENDING': {
      return { ...state, saving: true };
    }
    case 'EDIT_FOLDER_FULFILLED': {
      let { mediaFolders } = state;
      const index = _.findIndex(mediaFolders, folder => folder.id === payload.id);
      mediaFolders[index].name = payload.name;
      return { ...state, mediaFolders, saving: false };
    }
    case 'EDIT_FILE_PENDING': {
      return { ...state, saving: true };
    }
    case 'EDIT_FILE_FULFILLED': {
      let { mediaFiles } = state;
      const index = _.findIndex(mediaFiles, file => file.id === payload.id);
      mediaFiles[index] = payload;

      return { ...state, mediaFiles, saving: false };
    }
    case 'DELETE_FOLDER_FULFILLED': {
      let { mediaFolders } = state;
      let folderId = payload;
      mediaFolders = _.filter(mediaFolders, x => x.id !== folderId);
      return { ...state, mediaFolders };
    }
    case 'DELETE_FILE_FULFILLED': {
      let { mediaFiles } = state;
      let fileId = payload;
      mediaFiles = _.filter(mediaFiles, x => x.id !== fileId);
      return { ...state, mediaFiles };
    }
    case 'F_UPLOAD_PENDING': {
      return { ...state, saving: true };
    }
    case 'F_UPLOAD_FULFILLED': {
      let { files } = payload;
      let { already_exist_errors } = state;
      let mediaFiles;
      let alreadyExist = false;

      if(payload[0] === "already_exist"){
        mediaFiles = state.mediaFiles;
        alreadyExist = true;
        already_exist_errors.push(true);
      }
      else{
        already_exist_errors.push(false);
        mediaFiles = state.mediaFiles.concat(payload[0]);
      }

      return {
        ...state,
        saving: false, //files > 0 ? true : false,
        mediaFiles: mediaFiles,
        already_exist: alreadyExist,
        filesToUpload:payload.files,
      };
    }
    case 'SET_VARIABLES_MEDIA': {
      let status;
      let { already_exist_errors } = state;
      if(payload === "already_exist_false"){
        status = false;
      }
      if(payload === "already_exist_errors_reset"){
        already_exist_errors = [];
      }
      return {...state, already_exist: status, already_exist_errors: already_exist_errors}
    }
    case 'UPDATE_STORE': {
      return {...state, storeFR: payload}
    }
    case 'CONNECT_TO_PIXABAY_PENDING': {
      return { ...state, pendingP: true};
    }
    case 'CONNECT_TO_PIXABAY_FULFILLED': {
      let {pixabayFilesCache, pixabaySearchingTextCache } = state;
      let searching = [];
      let cache = pixabayFilesCache;
      let searchingText = pixabaySearchingTextCache;

      searching = payload[1];
      cache = pixabayFilesCache;
      cache.push(payload[1]);
      searchingText.push(payload[0]);

      return { ...state, pixabaySearching: searching, pixabayFilesCache: cache, pixabaySearchingTextCache: searchingText, pendingP: false };
    }
  }
  return state;
};
